<template>
  <report-section title="心率统计" class="hrv-section">
    <template v-slot:content>
      <div class="section-hrv-content">
        <div class="hrv-stats-grid">
          <!-- 第一行 -->
          <div class="hrv-item">
            <div class="hrv-label">分析心跳次数:</div>
            <div class="hrv-value">{{ reportDetailModel.hrvData?.cnt ?? '-' }}</div>
          </div>
          <div class="hrv-item">
            <div class="hrv-label">平均心率:</div>
            <div class="hrv-value">{{ reportDetailModel.hrvData?.meanBpm ?? '-' }}</div>
          </div>
          <div class="hrv-item">
            <div class="hrv-label">心动过速搏动次数 (>120bpm):</div>
            <div class="hrv-value">{{ reportDetailModel.hrvData?.fastBpmCnt ?? '-' }}</div>
          </div>
          <div class="hrv-item">
            <div class="hrv-label">占比:</div>
            <div class="hrv-value">{{ reportDetailModel.hrvData?.fastBpmRate ? Number(reportDetailModel.hrvData.fastBpmRate).toFixed(2) + '%' : '-' }}</div>
          </div>
          <div class="hrv-item">
            <div class="hrv-label">最小心率:</div>
            <div class="hrv-value">{{ reportDetailModel.hrvData?.minBpm ?? '-' }}</div>
          </div>
          <div class="hrv-item">
            <div class="hrv-label">发生时间:</div>
            <div class="hrv-value">{{ formatTimestamp(reportDetailModel.hrvData?.minBpmTimeStamp) }}</div>
          </div>
          
          <!-- 第二行 -->
          <div class="hrv-item">
            <div class="hrv-label">最大RR间隔:</div>
            <div class="hrv-value">{{ reportDetailModel.hrvData?.maxRr ?? '-' }}</div>
          </div>
          <div class="hrv-item">
            <div class="hrv-label">发生时间:</div>
            <div class="hrv-value">{{ formatTimestamp(reportDetailModel.hrvData?.maxRrTimeStamp) }}</div>
          </div>
          <div class="hrv-item">
            <div class="hrv-label">心动过缓搏动次数 (&lt;40bpm):</div>
            <div class="hrv-value">{{ reportDetailModel.hrvData?.slowBpmCnt }}</div>
          </div>
          <div class="hrv-item">
            <div class="hrv-label">占比:</div>
            <div class="hrv-value">{{ reportDetailModel.hrvData?.slowBpmRate ? Number(reportDetailModel.hrvData.slowBpmRate).toFixed(2) + '%' : '-' }}</div>
          </div>
          <div class="hrv-item">
            <div class="hrv-label">最大心率:</div>
            <div class="hrv-value">{{ reportDetailModel.hrvData?.maxBpm }}</div>
          </div>
          <div class="hrv-item">
            <div class="hrv-label">发生时间:</div>
            <div class="hrv-value">{{ formatTimestamp(reportDetailModel.hrvData?.maxBpmTimeStamp) }}</div>
          </div>
        </div>
      </div>
    </template>
  </report-section>
</template>

<script>
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
import { DateTool } from "@js/date-tool.js";

export default {
  components: {
    ReportSection
  },

  props: {
    reportDetailModel: Object
  },

  methods: {
    formatTimestamp(seconds) {
      if (!seconds && seconds !== 0) return '-';
      
      // 假设这是相对于测试开始时间的秒数
      const startTime = this.reportDetailModel.reportDetail?.startAt || 0;
      const timestamp = startTime + seconds * 1000;
      
      return DateTool.millisecondTimestampToStr(timestamp, "h:m");
    }
  }
};
</script>

<style lang="scss" scoped>
.hrv-section {
  /deep/ .report-section-title-text {
    @include report-section-title;
  }
}

.section-hrv-content {
  width: 100%;
  margin-bottom: 20px;
}

.hrv-stats-grid {
  display: grid;
  grid-template-columns:
    minmax(50px, 15.5%) 
    minmax(50px, 13%) 
    minmax(100px, 36.5%) 
    minmax(50px, 11.0%) 
    minmax(50px, 12.0%) 
    minmax(50px, 12%);
  // grid-template-rows: repeat(2, auto);
  gap: 10px;
  column-gap: 20px;
  width: 100%;
  @media print {
    width: 99%;
  }
}

.hrv-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}


.hrv-label {
  font-size: 16px;
  color: #000;
  white-space: nowrap;
}

.hrv-value {
  font-size: 16px;
  color: #000;
  font-weight: 500;
}

@media print {
  .hrv-section {
    /deep/ .report-section-title-text {
      @include report-section-title-print;
    }
  }
}
</style> 